"use client";

import { useForm } from "react-hook-form";
import React, { useEffect, useState } from "react";

import InvoicePublicModel from "@/common/models/InvoicePublicModel";
import Button from "@/components/ui/Button";
import InputBorder from "@/components/ui/InputBorder";
import { CloseIcon, SearchIcon } from "@/components/icons";
import LoadingTinySkeleton from "~components/skeleton/LoadingTinySkeleton";
import { getInvoiceDetailsPublic } from "@/lib/api/shop/invoice";
import BaseApi from "@/common/api/BaseApi";
import { InvoiceJson, InvoicePublicJson } from "@/types/Invoice.type";
import Popup from "@/components/Popup";
import { setPopupId } from "@/redux/features/ShopSlice";
import { useAppDispatch, useAppSelector } from "@/redux/hook";
import InvoicePublicCard from "./InvoicePublicCard";
import { cn } from "@/utils/utils";
import useTranslationApi from "@/lib/hooks/useTranslationApi";

function OrderStatusPopup() {
  const { t } = useTranslationApi([
    "order_status_title",
    "orderstatus_desc",
    "order_datecreated",
    "order_code",
    "order_status",
    "search",
    "error_order_code_invalid",
    "error_required",
    "search_order_placeholder",
    "view_more",
  ]);
  //states

  const [code, setCode] = useState("");
  const [keyword, setKeyword] = useState("");
  const [errors, setErrors] = useState<string[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [open, setOpen] = useState<boolean>(false);
  const [invoice, setInvoice] = useState<InvoiceJson | null>(null);
  const dispatch = useAppDispatch();
  //hooks
  const {
    control,
    handleSubmit,
    setValue,
    getValues,
    setError: setErrorForms,
    clearErrors,
    formState: { errors: errorForms },
  } = useForm({
    reValidateMode: "onSubmit",
    mode: "onSubmit",
    defaultValues: {
      code: code,
    },
  });

  //functions
  function onSubmitForm(data: { code: string }) {
    setCode(data.code);
  }

  const onClear = (e: any) => {
    e.stopPropagation();
    setCode("");
    setKeyword("");
    setValue("code", "");
    setErrors([]);
    clearErrors();
  };

  //fetch data
  async function getOrder(code: string) {
    setLoading(true);

    try {
      const res = await getInvoiceDetailsPublic(code);
      setErrors([]);
      setInvoice(res.data);
    } catch (error) {
      const dataError = BaseApi.handleError(error);
      setErrors(dataError.errors);
      setErrorForms("code", {
        message: t("error_order_code_invalid"),
      });
      setInvoice(null);
    } finally {
      setLoading(false);
    }
  }

  //
  useEffect(() => {
    code.length > 0 && getOrder(code);
  }, [code]);

  return (
    <Popup
      popupId="popup-order-status"
      closeOnMark={false}
      classNameContent="w-[90vw] md:w-[60vw] md:max-w-[800px] rounded-lg bg-white rounded-lg p-4 md:p-6"
      handleOnClose={() => {
        // setLoading(true)
        setCode("");
        setValue("code", "");
        dispatch(setPopupId(""));
        setInvoice(null);
      }}
    >
      <div>
        <h1 className="text-base font-medium md:text-2xl text-gray-500 mb-3 md:mb-8">
          {t("order_status_title")}
        </h1>
        <form
          className="w-full flex items-center justify-center gap-2 md:gap-3"
          onSubmit={handleSubmit(onSubmitForm)}
        >
          <div className="flex-1 h-[40px] relative">
            <InputBorder
              control={control}
              onKeyUp={() => setKeyword(getValues("code"))}
              name="code"
              placeholder={t("search_order_placeholder")}
              rules={{ required: t("error_required") }}
              showError={false}
              errorClassName="top-[40px]"
              className={cn(
                "h-[40px] leading-[40px] pl-10 pr-2 py-2 border-gray-300 text-sm absolute w-full placeholder:text-gray-400 placeholder:text-sm",
                { "border-red-500": errorForms.code?.message }
              )}
              inputClassName="w-full h-full"
            />
            <SearchIcon className="w-6 h-6 min-w-[24px] absolute top-2 left-3" />
            {keyword.length > 0 && (
              <span
                onClick={(e: any) => onClear(e)}
                className="absolute top-2 right-2 flex items-center justify-center cursor-pointer"
              >
                <CloseIcon />
              </span>
            )}
          </div>
          <Button
            className="h-[40px] w-fit md:w-[114px] px-[14px] py-2"
            mode="main"
            type="submit"
          >
            {t("search")}
          </Button>
        </form>
        {loading ? (
          <LoadingTinySkeleton />
        ) : (
          <div className="mt-2">
            {/* {errors.length > 0 && (
              <p className="text-sm text-red-500 mb-4">
                Mã đơn hàng không đúng.
              </p>
            )} */}
            {errorForms.code && (
              <p className="text-sm text-red-500 mb-4">
                {errorForms.code.message}
              </p>
            )}
            {invoice && invoice.code.length > 0 && (
              <div className="text-sm text-gray-500">
                <InvoicePublicCard
                  data={invoice}
                  open={open}
                  onClick={(e: any) => {
                    e.stopPropagation();
                    setOpen(!open);
                  }}
                />

                {/* <p>
									<span className="font-semibold">Mã đơn hàng:</span>{" "}
									{invoice.code}
								</p>
								<p>
									<span className="font-semibold">Khách hàng:</span>{" "}
									{invoice.customer_name}
								</p>
								<p>
									<span className="font-semibold">Tổng tiền:</span>{" "}
									<Money value={invoice.total} /> ({invoice.payment_method})
								</p>
								<p>
									<span className="font-semibold">Trạng thái:</span>{" "}
									{invoice.status_value}
								</p> */}
              </div>
            )}
          </div>
        )}
      </div>
    </Popup>
  );
}

export default OrderStatusPopup;
